import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SurveyTopViewComponent } from './survey-top-view.component';

import { DropdownModule } from '@purespectrum1/ui/dropdown';

import { CardRowComponent } from './card-row/card-row.component';

import { FieldedCardComponent } from './fielded-card/fielded-card.component';

import { IncidenceCardComponent } from './incidence-card/incidence-card.component';

import { CpiCardComponent } from './cpi-card/cpi-card.component';
import { LoiCardComponent } from './loi-card/loi-card.component';
import { CardModule } from '@purespectrum1/ui/card';

export * from './survey-top-view.component';
export * from './card-row/card-row.component';
export * from './fielded-card/fielded-card.component';
export * from './total-cost-card/total-cost-card.component';
export * from './cpi-card/cpi-card.component';
export * from './loi-card/loi-card.component';
export * from './incidence-card/incidence-card.component';

import { TotalCostCardComponent } from './total-cost-card/total-cost-card.component';

@NgModule({
  imports: [CommonModule, DropdownModule, CardModule],
  declarations: [
    CardRowComponent,
    FieldedCardComponent,
    IncidenceCardComponent,
    SurveyTopViewComponent,
    CpiCardComponent,
    LoiCardComponent,
    TotalCostCardComponent,
  ],
  exports: [
    CardRowComponent,
    FieldedCardComponent,
    IncidenceCardComponent,
    SurveyTopViewComponent,
    CpiCardComponent,
    LoiCardComponent,
    TotalCostCardComponent,
  ],
})
export class SurveyTopViewModule {}
